'use client';

import { useNavigationEffects } from '@/hooks/useNavigationEffects';
import { useScrollManager } from '@/hooks/useScrollManager';

export default function NavigationEffectsProvider() {
  useNavigationEffects();
  useScrollManager({ manual: true }); // or move to pages where you want it
  return null;
}